import type {ReactNode} from 'react'

function ProgressBar({step, total}: {step: number; total: number}) {
  return (
    <div className="mb-4">
      <div className="mb-2 flex justify-between text-[11px] text-black/55">
        <span>
          Step {step + 1} of {total}
        </span>
      </div>
      <div className="h-1 overflow-hidden rounded bg-black/[0.08]">
        <div
          className="h-full rounded bg-green-neon transition-[width] duration-300"
          style={{
            width: `${((step + 1) / total) * 100}%`,
            transitionTimingFunction: 'cubic-bezier(0.25, 0, 0, 1)',
          }}
        />
      </div>
    </div>
  )
}

export function FormPanel({step, total, children}: {step: number; total: number; children: ReactNode}) {
  return (
    <div className="flex h-[750px] flex-col overflow-hidden rounded-[10px] border border-black/[0.08] bg-moss-white p-[22px]">
      <ProgressBar step={step} total={total} />
      <div className="flex min-h-0 flex-1 flex-col">{children}</div>
    </div>
  )
}
